import { useEffect, useState } from 'react';
import CustomCamera from './CustomCamera';
import { AddCameraBtnContainer, CaiCameraButton } from '../styled/Button.style';
import { dataURLtoFile, uploadExecutionHandler } from '../../utils/utils-file';
import { FileActionFunction } from '../../types/communication/communicationDataType';
import cameraSvg from './../../assets/svg/camera.svg'
import plusSvg from './../../assets/svg/plus.svg'
import { FileCtaContainer } from '../styled/File.style';
import CameraConfirmationPage from './CameraConfirmationPage';
import { PhotoTypeEnum } from '../../types/commonTypes';
import { getExifBytes } from './camera.utils';

interface CameraUploadCmpProps {
  customContainerClass?: string
  isInFileList?: boolean
  customBtnClass?: string
  photoClickHandler?: any
  onCloseHandler: any
  rightItem?: any
  leftItem?: any
  overlaySuggestItem?: any
  mainLabelItem?: any
  showCamera: boolean
  setShowCamera: any
  needPhotoConfirmBeforeUploading?: boolean

  files?: any[]
  onFileAdded: FileActionFunction
  onFileRemoved: FileActionFunction
  showSupportedFilesInfo?: boolean
  className?: string
  textLabel?: string
  forceCameraOnly?: boolean
  token: string
  hideCameraAddButton?: boolean
  fileType: PhotoTypeEnum
  additionalBeInfo: any
}

/* istanbul ignore next */
const CameraUploadCmp = (props: CameraUploadCmpProps) => {
  const { customContainerClass, isInFileList, customBtnClass, photoClickHandler, onCloseHandler,
    leftItem, rightItem, mainLabelItem, overlaySuggestItem,
    showCamera, needPhotoConfirmBeforeUploading, setShowCamera,
    textLabel, token, hideCameraAddButton, onFileAdded, onFileRemoved,
    fileType, additionalBeInfo
  } = props;
  const [exifBytes, setExifBytes] = useState<any>(null);

  useEffect(() => {
    // compute Exif data
    const computeExifData = async () => {
      const currentExifBytes = await getExifBytes()
      if (currentExifBytes) {
        setExifBytes(currentExifBytes)
      }
    }
    computeExifData()
  }, []);

  const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const [showConfirmPhoto, setShowConfirmPhoto] = useState(false)
  const [currentPhoto, setCurrentPhoto] = useState<any>(null)

  const uploadPhotoHandler = (_ph: any) => {
    const filename = `${token}_${Date.now()}.jpg`;
    const file = dataURLtoFile(_ph, filename)
    const event = { target: { files: [file] } }
    uploadExecutionHandler(event, fileType || 'image/png', token, onFileRemoved, onFileAdded, additionalBeInfo)
    photoClickHandler && photoClickHandler(_ph)
  }

  const setPhotoHandler = (_ph: any) => {
    // check if there need for confirm beforeis confirm 
    if (needPhotoConfirmBeforeUploading) {
      setCurrentPhoto(_ph)
      setShowConfirmPhoto(true)
    } else {
      uploadPhotoHandler(_ph)
    }
  }

  const confirmPageSubmitHandler = (_ph: any) => {
    setShowConfirmPhoto(false)
    uploadPhotoHandler(currentPhoto)
  }

  const isInFileListClass = isInFileList ? 'is-in-file-list' : ''
  const addBtnContent = isInFileList ? <>
    <img src={plusSvg} alt="plus icon" />
  </> :
    <>
      <img src={cameraSvg} alt="camera icon" />
      <label> {textLabel || 'SCATTA FOTO'}</label>
    </>

  return (
    <>
      {!hideCameraAddButton && <AddCameraBtnContainer
        onClick={() => setShowCamera(true)}>
        <CaiCameraButton className={`solid-btn with-icon camera-add-photo ${customBtnClass} ${isInFileListClass}`}>
          {addBtnContent}
        </CaiCameraButton>
        <FileCtaContainer
          className={`${isInFileListClass}`}>Aggiungi foto</FileCtaContainer>
      </AddCameraBtnContainer>}

      {showConfirmPhoto && <CameraConfirmationPage
        photo={currentPhoto}
        confirmHandler={confirmPageSubmitHandler}
        revertHandler={() => setShowConfirmPhoto(false)}
        closeCameraHandler={onCloseHandler}
        isiOS={isiOS}
      />}

      {showCamera && <CustomCamera
        isiOS={isiOS}
        exifBytes={exifBytes}
        customContainerClass={customContainerClass}
        onCloseHandler={onCloseHandler}
        setPhotoHandler={setPhotoHandler}
        leftItem={leftItem}
        rightItem={rightItem}
        mainLabelItem={mainLabelItem}
        overlaySuggestItem={overlaySuggestItem}
      />}
    </>
  );
};

export default CameraUploadCmp;
